import { render } from "./QueryChartPreview.vue?vue&type=template&id=801d7c16&ts=true"
import script from "./QueryChartPreview.vue?vue&type=script&lang=ts"
export * from "./QueryChartPreview.vue?vue&type=script&lang=ts"

import "./QueryChartPreview.vue?vue&type=style&index=0&id=801d7c16&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QSpace,QBtn,QSeparator,QCardActions});qInstall(script, 'directives', {ClosePopup});
